<template>
    <div>
      <div class="breadcrumbs" id="breadcrumbs">
        <router-link class="breadcrumb-link" to="/corporate-products/">All Corporate Products</router-link> &gt;
        <router-link class="breadcrumb-link" to="/corporate-products/requests">Product Requests</router-link>  &gt;
        <router-link class="breadcrumb-link" :to="'/corporate-products/requests/'+item.id">{{ item.name }}</router-link>
      </div>
        <h3>{{ item.name }} <span>Product Request</span></h3>
        <table id="list-of-campaigns" class="ws-table-summary">
            <thead>
            <tr>
                <th>Product Name</th>
                <th>Product Type</th>
                <th>Request Type</th>
                <th>Status</th>
                <th>Request Date</th>
                <th>Stock Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td class="field-name" data-label="Product Name"><div class="value"><b>{{ item.name }}</b></div></td>
                <td class="field-uppercase field-p_type" data-label="Product Type"><div class="value">{{ item.product_type }}</div></td>
                <td class="field-request_type" data-label="Request Type"><div class="value">{{ item.request_type === 'new' ? 'New Item' : 'Restock'}}</div></td>
                <td class="field-status" data-label="Status" :data-status="item.status"><div class="value">{{ item.status }}</div></td>
                <td class="field-created_at" data-label="Request Date"><div class="value">{{ item.created_at }}</div></td>
                <td class="field-stock" data-label="Stock Amount"><div class="value">{{ item.stock }}</div></td>

            </tr>
            </tbody>
        </table>
        <div class="tool-actions">
            <a v-if="item.product_id" class="ws-button" :href="'/corporate-products/' + item.product_id">View Product</a>
            <a v-if="item.status === 'pending' && item.team_id == currentTeamId" class="ws-button" @click="openEditModal()">Edit Product Request</a>
            <a v-if="item.status === 'pending' && item.team_id == currentTeamId" class="ws-button ws-button-negative" @click="cancelRequest(item.id)">Cancel Product Request</a>
        </div>

        <h4>Product Request Details</h4>
        <div class="simple-panel" style="max-width: 500px;" v-if="item.request_type === 'new'">
          <div class="simple-panel-item" v-if="item.product_type === 'product'">
              <h5>Base Product</h5>
              <p>{{ item.base_product }}</p>
          </div>
          <div class="simple-panel-item">
              <h5>Description</h5>
              <p>{{ item.description }}</p>
          </div>
          <div class="simple-panel-item" v-if="(item.product_type === 'product') && item.customisation">
              <h5>Customisation</h5>
              <p>{{ item.customisation }}</p>
          </div>
          <div class="simple-panel-item" v-if="item.product_type === 'giftbox'">
              <h5>Gift Box Content</h5>
              <p>{{ item.box_content }}</p>
          </div>
        </div>
        <product-requests-modal v-if="modals.productRequestsEdit" :fetch-item="true" :request-id="item.id" @updated="onUpdated" :type="'edit'"></product-requests-modal>
    </div>
</template>

<script>
import ProductRequestsModal from '@/pages/corporate-products/ProductRequestsModal';

export default {
    name: "ProductRequestsDetail",
    components: {ProductRequestsModal},
    data() {
        return {

        }
    },
    methods: {
        async fetchData() {
            try {
                await this.dispatchWaitAndNotify('fetchProductRequest', {requestId: this.$route.params.id}, false, true);
            } catch (e) {
                if (e.response?.status === 404) {
                    this.$router.push('/corporate-products/requests');
                }
            }
        },
        async cancelRequest(requestId) {
            if (!this.demoCheck()) return;
            
            await this.dispatchWaitAndNotify('updateProductRequest', {requestId, payload: {status:'cancelled'}});
            this.fetchData();
        },
        onUpdated() {
            this.modals.productRequestsEdit = false;
            this.fetchData();
        },
        openEditModal() {
            this.modals.productRequestsEdit = true;
        }
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        item() {
            return this.$store.state.product.request.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        currentTeamId() {
            console.log(this.$store.state.teamId);
            return this.$store.state.teamId;
        }
    },
}
</script>

<style scoped>

</style>
